// extracted by mini-css-extract-plugin
module.exports = {"neutral4":"#d9d8d8","comboBoxContainer":"DynamicControlsComboBox__comboBoxContainer","dynamicControlsDropDownList":"DynamicControlsComboBox__dynamicControlsDropDownList"};